document.addEventListener('DOMContentLoaded', async () => {
  const { on } = await import('delegated-events')
  const modal = document.querySelector('#popupBanner') as HTMLElement

  if (modal) {

    const showAlways = modal.getAttribute('data-banner-show-always')

    if (showAlways) {
      modal.style.setProperty('display', 'flex')
    } else {

      const bannerId = modal.getAttribute('data-banner-id') || ''
      const popUpBannerStorageName = 'popUpBanner_' + bannerId

      let showBanner = false
      const bannerExpiration = window.localStorage.getItem(popUpBannerStorageName)
      if (bannerExpiration) {
        const expireDate = Number(bannerExpiration)
        const currentDate = new Date().getTime()
        if (currentDate > expireDate) {
          showBanner = true
        }
      } else {
        showBanner = true
      }

      if (showBanner) {
        const endOfDay = new Date()
        endOfDay.setHours(23, 59, 59, 999)
        window.localStorage.setItem(popUpBannerStorageName, endOfDay.getTime().toString())
        modal.style.setProperty('display', 'flex')
      }
    }
  }

  on('click', '.PopupBanner__close', () => {
    modal?.style.setProperty('display', 'none')
  })
})
